import React from 'react';

export interface ImageWithZoomProps {
  url: string;
  alt?: string;
  index: number;
  onClick?: (index: number) => void;
}

const ImageWithZoom: React.FC<ImageWithZoomProps> = ({ url, alt, onClick, index }) => {
  return (
    <div className="ecom-img-zoom__wrapper">
      <img src={url} alt={alt} onClick={() => onClick && onClick(index)} className="ecom-img-zoom__img" />
    </div>
  );
};

export default ImageWithZoom;
